// extracted by mini-css-extract-plugin
module.exports = {"container":"eeb6c9d23e--container--am1zf","promo-block":"eeb6c9d23e--promo-block--Zw6z8","pik-logo":"eeb6c9d23e--pik-logo--CQGDQ"};